import * as actions from './actions';

const initialState = {
    isSaveInProgress: false,
    isDataLoaded: false
};

export default function (state = initialState, action) {
    switch (action.type) {
    case actions.GET_ACTIVITY_ASSIGN_PREFERENCE_SUCCESS: {
        return { ...state, activityAssignPreferences: action.data, isDataLoaded: true };
    }
    case actions.RESET_ACTIVITY_ASSIGN_PREFERENCE_REQUEST:
    case actions.SAVE_ACTIVITY_ASSIGN_PREFERENCE_REQUEST: {
        return { ...state, isSaveInProgress: true };
    }
    case actions.RESET_ACTIVITY_ASSIGN_PREFERENCE_SUCCESS:
    case actions.SAVE_ACTIVITY_ASSIGN_PREFERENCE_SUCCESS: {
        return { ...state, isSaveInProgress: false };
    }
    case actions.RESET_ACTIVITY_ASSIGN_PREFERENCE_FAILURE:
    case actions.SAVE_ACTIVITY_ASSIGN_PREFERENCE_FAILURE: {
        return { ...state, isSaveInProgress: false };
    }
    default:
        return { ...state };
    }
}




// WEBPACK FOOTER //
// ./app/containers/activity-assign-preference/reducer.js